import { OTP_SCREEN_ID } from 'constants/analytics';

import { ActionEventAction, ElementEventAction, EventTriggerFixed, Main } from 'services/Analytics/core';

import { trackClick, trackEventFixed } from './mainTrackers';

export const sendAnalyticLoginClick = (eventLabel?: string) => {
    trackClick({
        screenIdParam: OTP_SCREEN_ID,
        elementEvent: ElementEventAction.button,
        actionEvent: ActionEventAction.continue,
        ...(eventLabel && { eventLabel }),
    });
};
export const sendAnalyticLoginSuccess = () => {
    trackEventFixed({ event: EventTriggerFixed.loginSuccess, isEventSchemaKey: true });
};

export const sendAnalyticLoginError = (eventLabel?: Record<string, string>) => {
    trackEventFixed({ event: EventTriggerFixed.loginError, eventLabel });
};

export const sendAnalyticLoginWithTokenStart = () => {
    Main.trackNew({
        eventData: 'login_with_token',
    });
};

export const sendAnalyticLoginWithTokenSuccess = () => {
    Main.trackNew({
        eventData: 'login_with_token_success',
    });
};

export const sendAnalyticLoginWithTokenError = (eventLabel?: string) => {
    Main.trackNew({
        eventData: 'login_with_token_error',
        data: {
            ...(eventLabel && { event_label: eventLabel }),
        },
    });
};

export const sendAnalyticOldTypeTokenUser = () => {
    Main.trackNew({
        eventData: 'new_token_assigned__success',
    });
};

export const sendAnalyticNewTypeTokenUser = () => {
    Main.trackNew({
        eventData: 'new_token_assigned__exist',
    });
};

export const sendAnalyticLoginButtonClick = (eventLabel?: string) => {
    trackClick({
        screenIdParam: OTP_SCREEN_ID,
        ...(eventLabel && { eventLabel }),
    });
};
